// extracted by mini-css-extract-plugin
module.exports = {"modal":"ActionModal_modal__35W1z","cancel":"ActionModal_cancel__13ZmU","ok":"ActionModal_ok__1BHvW"};